import React from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Container,
  Divider,
  Grid,
  InputLabel,
  makeStyles,
  MenuItem,
  TextField
} from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Paper from '@material-ui/core/Paper';
import Tab from '@material-ui/core/Tab';
import TabContext from '@material-ui/lab/TabContext';
import TabList from '@material-ui/lab/TabList';
import TabPanel from '@material-ui/lab/TabPanel';
import { Formik } from 'formik';
import { Fragment, useEffect, useState } from 'react';
import { useAlert } from "react-alert";
import { trackPromise } from 'react-promise-tracker';
import { useNavigate, useParams } from 'react-router-dom';
import Page from 'src/components/Page';
import { AlertDialogWithoutButton } from 'src/views/Common/AlertDialogWithoutButton';
import PageHeader from 'src/views/Common/PageHeader';
import * as Yup from "yup";
import { LoadingComponent } from '../../../../utils/newLoader';
import authService from '../../../../utils/permissionAuth';
import tokenService from '../../../../utils/tokenDecoder';
import services from '../../Services';
import Grading from '../TabViews/TabFourExsesLoss';
import WitheredLeaf from '../TabViews/TabOneWitheredLeaf';
import Fiering from '../TabViews/TabThreeFiering';
import Rolling from '../TabViews/TabTwoRolling';
import FuelConsume from './TabFiveFuelConsume';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  row: {
    marginTop: '1rem'
  }
}));
const screenCode = 'NEWMANUFACTURING';

export default function NewManufacturingAddEditMain(props) {
  const { manufacturingID, statusID } = useParams();
  let decryptedID = 0;
  let decryptedStatusID = 0;
  const alert = useAlert();
  const classes = useStyles();
  const [GroupList, setGroupList] = useState([]);
  const [factoryList, setFactoryList] = useState([]);
  const [warehouseList, setWarehouseList] = useState([]);
  const [arrayField, setArrayField] = useState([]);
  const [arrayFuel, setArrayFuel] = useState([]);
  const [greenLeafArray, setGreenLeafArray] = useState([]);
  const [manufactureTypes, setManufactureTypes] = useState([]);
  const [decryptedIDD, setDecryptedID] = useState(0);
  const [decryptedStatusIDD, setDecryptedStatusID] = useState(0);
  const [dialogboxOne, setDialogboxOne] = useState(false);
  const [dialogboxTwo, setDialogboxTwo] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [isGrading, setIsGrading] = useState(false);
  const [percentageError, setPercentageError] = useState(false);
  const [manufacturingDetail, setManufacturingDetail] = useState({
    groupID: 0,
    factoryID: 0,
    manufactureNumber: '',
    greenLeafAmount: 0,
    boughtLeafWeight: 0,
    estateLeafWeight: 0,
    interEstateLeafWeight: 0,
    fromDateOfCrop: '',
    toDateOfCrop: '',
    fromDateOfManufacture: '',
    toDateOfManufacture: '',
    best: 0,
    belowBest: 0,
    poor: 0,
    statusID
  });
  const [witheringDetails, setWitheringDetails] = useState({
    startDate: "",
    endDate: "",
    witheredLeafAmount: 0,
    witheredLeafPercentage: 0,
    witheringCondition: 0,
  });

  const [rollingDetails, setRollingDetails] = useState({
    manufactureTypeCode: "",
    manufactureTypeID: "0",
    rollingStartTime: "",
    rollingEndDate: "",
    noOfDhool: 0,
    noOfBatch: 0
  });
  const [firingDetails, setFiringDetails] = useState({
    startDateTime: "",
    endDateTime: "",
    fireWeight: 0,
    grossOutTurn: 0,
    temperature: 0,
    temperatureUnitID: 0,
    moistureGain: 0,
    totalFireWeight: 0,
    grandGrossOutTurn: 0,
    selectedDhools: [],
  });

  const [gradeDetails, setGradeDetails] = useState({
    remainingAmount: 0,
    refuseAmount: 0,
    refusePercentage: 0,
    netOutTurn: 0
  });

  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
    isApproveButtonEnabled: false,
  });

  const [maxQty, setMaxQty] = useState({
    boughtLeafMaxWeight: 0,
    estateLeafMaxWeight: 0,
    interEstateLeafMaxWeight: 0,
  })

  const navigate = useNavigate();
  const [value, setValue] = useState(1);
  const handleChangetab = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    trackPromise(
      getPermission(), getGroupsForDropdown()
    );
  }, []);

  useEffect(() => {
    decryptedID = atob(manufacturingID.toString());
    decryptedStatusID = atob(statusID.toString());
    setDecryptedStatusID(decryptedStatusID)
    if (decryptedID != 0) {
      trackPromise(GetManufactureDetailsByManufacturingID(decryptedID));
      setDecryptedID(decryptedID)
      setIsUpdate(true);
    }
  }, []);

  useEffect(() => {
    trackPromise(
      getFactoriesForDropdown()
    );
  }, [manufacturingDetail.groupID]);

  useEffect(() => {
    trackPromise(
      GetWarehouseDetailsByFactoryID(), GetManufactureTypes()
    );
  }, [manufacturingDetail.factoryID]);

  useEffect(() => {
    if (manufacturingDetail.factoryID != 0 && manufacturingDetail.fromDateOfCrop != "" && manufacturingDetail.toDateOfCrop != "" && !isUpdate) {
      trackPromise(
        GetGreenLeafQuantityForManufacture()
      );
    }
    if (manufacturingDetail.factoryID != 0 && manufacturingDetail.fromDateOfCrop != "" && manufacturingDetail.toDateOfCrop != "" && isUpdate) {
      decryptedID = atob(manufacturingID.toString());
      trackPromise(
        GetGreenLeafQuantityForUpdate(decryptedID),
        GetWitheredLeafQtyForUpdate(decryptedID)
      );
    }
  }, [manufacturingDetail.factoryID, manufacturingDetail.fromDateOfCrop, manufacturingDetail.toDateOfCrop]);

  useEffect(() => {
    if (manufactureTypes.length > 0) {
      if (rollingDetails.manufactureTypeID == 0) {
        setRollingDetails((prevState) => ({
          ...prevState,
          manufactureTypeID: manufactureTypes[0].manufactureTypeID,
          manufactureTypeCode: manufactureTypes.find(x => x.manufactureTypeID == parseInt(manufactureTypes[0].manufactureTypeID))?.manufactureTypeCode
        }));
      }
    }
  }, [manufactureTypes]);

  useEffect(() => {
    if (!isUpdate) {
      setManufacturingDetail((prevState) => ({
        ...prevState,
        greenLeafAmount: (parseFloat(manufacturingDetail.boughtLeafWeight) || 0) + (parseFloat(manufacturingDetail.estateLeafWeight) || 0) + (parseFloat(manufacturingDetail.interEstateLeafWeight) || 0)
      }));
    }
  }, [manufacturingDetail.boughtLeafWeight, manufacturingDetail.estateLeafWeight, manufacturingDetail.interEstateLeafWeight]);

  useEffect(() => {
    if (manufacturingDetail.best !== 0 || manufacturingDetail.belowBest !== 0 || manufacturingDetail.poor !== 0) {
      let totalpercent = parseFloat(manufacturingDetail.best) + parseFloat(manufacturingDetail.belowBest) + parseFloat(manufacturingDetail.poor);
      if (totalpercent == 100) {
        setPercentageError(false);
      } else {
        setPercentageError(true);
      }
    } else {
      setPercentageError(false);
    }
    if (manufacturingDetail.best == 0 && manufacturingDetail.belowBest == 0 && manufacturingDetail.poor == 0) {
      setPercentageError(false);
    }
  }, [manufacturingDetail.best, manufacturingDetail.belowBest, manufacturingDetail.poor]);

  async function getPermission() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITNEWMANUFACTURING');
    if (isAuthorized === undefined) {
      navigate('/404');
    }
    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');
    var isApproveButtonEnabled = permissions.find(p => p.permissionCode == 'APPROVEBUTTON');
    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
      isApproveButtonEnabled: isApproveButtonEnabled !== undefined,
    });
    setManufacturingDetail({
      ...manufacturingDetail,
      groupID: parseInt(tokenService.getGroupIDFromToken()),
      factoryID: parseInt(tokenService.getFactoryIDFromToken())
    })
  }

  async function getGroupsForDropdown() {
    const groups = await services.getGroupsForDropdown();
    setGroupList(groups);
  }

  async function getFactoriesForDropdown() {
    const factories = await services.getFactoryByGroupID(manufacturingDetail.groupID);
    setFactoryList(factories);
  }

  async function GetWarehouseDetailsByFactoryID() {
    const details = await services.GetWarehouseDetailsByFactoryID(manufacturingDetail.factoryID);
    setWarehouseList(details)
  }

  async function GetManufactureTypes() {
    const types = await services.GetManufactureTypes(manufacturingDetail.factoryID);
    setManufactureTypes(types);
  }

  async function GetGreenLeafQuantityForManufacture() {
    if (rollingDetails.manufactureTypeCode == "03") {
      const details = await services.GetRefuseTeaQuantityForManufacture(manufacturingDetail.factoryID, manufacturingDetail.fromDateOfCrop, manufacturingDetail.toDateOfCrop);
      if (details.totalLeafWeight != 0) {
        setManufacturingDetail((prevState) => ({
          ...prevState,
          greenLeafAmount: details.totalLeafWeight
        }));
        setWitheringDetails((prevState) => ({
          ...prevState,
          witheredLeafAmount: details.totalLeafWeight
        }));
        setGreenLeafArray(details.details)
      }
      else {
        setManufacturingDetail((prevState) => ({
          ...prevState,
          greenLeafAmount: 0
        }));
        setWitheringDetails((prevState) => ({
          ...prevState,
          witheredLeafAmount: 0
        }));
        setGreenLeafArray([])
        alert.error("Not available Refuse Tea Quantity!");
      }
    }
    else {
      const details = await services.GetGreenLeafQuantityForManufacture(manufacturingDetail.factoryID, manufacturingDetail.fromDateOfCrop, manufacturingDetail.toDateOfCrop);
      if (details.totalLeafWeight != 0) {
        setManufacturingDetail((prevState) => ({
          ...prevState,
          boughtLeafWeight: details.totalRemainingBoughtLeafWeight,
          estateLeafWeight: details.totalRemainingEstateLeafWeight,
          interEstateLeafWeight: details.totalRemainingInterEstateLeafWeight,
        }));
        setMaxQty((prevState) => ({
          boughtLeafMaxWeight: details.totalRemainingBoughtLeafWeight,
          estateLeafMaxWeight: details.totalRemainingEstateLeafWeight,
          interEstateLeafMaxWeight: details.totalRemainingInterEstateLeafWeight
        }))
        setGreenLeafArray(details.details)
      }
      else {
        setManufacturingDetail((prevState) => ({
          ...prevState,
          boughtLeafWeight: 0
        }));
        setWitheringDetails((prevState) => ({
          ...prevState,
          witheredLeafAmount: 0
        }));
        setGreenLeafArray([])
        alert.error("Not available Green Leaf Quantity!");
      }
    }
  }

  async function GetGreenLeafQuantityForUpdate(decryptedID) {
    const details = await services.GetBaughtLeafDeductionQtyForUpdate(decryptedID);
    if (details.totalLeafWeight != 0) {
      setManufacturingDetail((prevState) => ({
        ...prevState,
        boughtLeafWeight: details[0].totalRemainingBoughtLeafWeight,
        estateLeafWeight: details[0].totalRemainingEstateLeafWeight,
        interEstateLeafWeight: details[0].totalRemainingInterEstateLeafWeight,
      }));
      setMaxQty((prevState) => ({
        boughtLeafMaxWeight: details[0].totalRemainingBoughtLeafWeight,
        estateLeafMaxWeight: details[0].totalRemainingEstateLeafWeight,
        interEstateLeafMaxWeight: details[0].totalRemainingInterEstateLeafWeight
      }))
    }
  }

  async function GetWitheredLeafQtyForUpdate(decryptedID){
    const withereddetails = await services.GetWitheredLeafQtyForUpdate(decryptedID);
    if(withereddetails.statusCode == "success"){
      setWitheringDetails({
        startDate: withereddetails.data.startDate,
        endDate: withereddetails.data.endDate,
        witheredLeafAmount: withereddetails.data.witheredLeafAmount,
        witheredLeafPercentage: withereddetails.data.witheredLeafPercentage,
        witheringCondition: withereddetails.data.witheringCondition,
      });
    }
  }

  async function handleClick() {
    navigate('/app/newmanufacturing/listing')
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
        <Grid item md={2} xs={12}>
          <PageHeader
            onClick={() => handleClick()}
            isEdit={false}
          />
        </Grid>
      </Grid>
    )
  }

  async function GetManufactureDetailsByManufacturingID(manufacturingID) {
    let response = await services.GetManufactureDetailsByManufacturingID(manufacturingID);
    if (response.length != 0) {
      setIsUpdate(true);
      setManufacturingDetail((prevState) => ({
        ...prevState,
        groupID: response.groupID,
        factoryID: response.factoryID,
        manufactureNumber: response.manufactureNumber,
        greenLeafAmount: response.greenLeafQuantity,
        fromDateOfCrop: response.fromDateOfCrop.split('T')[0],
        toDateOfCrop: response.toDateOfCrop.split('T')[0],
        fromDateOfManufacture: response.fromDateOfManufacture.split('T')[0],
        toDateOfManufacture: response.toDateOfManufacture.split('T')[0],
        best: response.best,
        belowBest: response.belowBest,
        poor: response.poor,
        statusID: response.manufactureStatus
      }));
      if (response.manufactureStatus != 1 && response.ManufactureStatus != 2) {
        setFiringDetails((prevState) => ({
          ...prevState,
          startDateTime: response.firingStartTime,
          endDateTime: response.firingEndTime,
          fireWeight: response.totalFireWeight,
          temperature: response.temperature,
          temperatureUnitID: response.temperatureUnitID,
          moistureGain: response.moistureGain,
          totalFireWeight: (response.fireWeight + response.refuseAmount),
          grandGrossOutTurn: response.grandGrossOutTurn,
          grossOutTurn: response.grossOutTurn,
          selectedDhools: response.dhoolDetails
        }));
      }
      if (response.manufactureStatus == 4 || response.manufactureStatus == 5) {
        setGradeDetails((prevState) => ({
          ...prevState,
          refuseAmount: response.refuseAmount
        }));
      }
      setWitheringDetails((prevState) => ({
        ...prevState,
        startDate: response.startDate,
        endDate: response.endDate,
        witheredLeafAmount: response.witheredLeafAmount,
        witheringCondition: response.witheringCondition,
        witheredLeafPercentage: manufacturingDetail.greenLeafAmount > 0 ? parseFloat((response.witheredLeafAmount / manufacturingDetail.greenLeafAmount) * 100).toFixed(1) : 0
      }));
      if (response.manufactureStatus != 1) {
        setRollingDetails((prevState) => ({
          ...prevState,
          manufactureTypeID: response.manufactureTypeID,
          manufactureTypeCode: response.manufactureTypeCode,
          rollingStartTime: response.startTime,
          rollingEndDate: response.endTime,
          noOfDhool: response.noOfDhool,
          noOfBatch: response.noOfBatch,
          selectedDhools: response.dhoolDetails
        }));
      }
      if (response.manufactureStatus == 4 || response.manufactureStatus == 5) {
        setArrayField(response.gradingDetails)
      }
      setArrayFuel(response.fuelDetails)
    }
  }

  function formatDateToLocal(date) {
    if (!date) return "";
    const d = new Date(date);
    return d.toISOString().slice(0, 16);
  }

  function handleChange(e) {
    const target = e.target;
    const value = target.value;

    if (target.name === "best" || target.name === "belowBest" || target.name === "poor") {
      if (value === "") {
        setManufacturingDetail({
          ...manufacturingDetail,
          [target.name]: value
        });
        return;
      }
      const numValue = parseFloat(value);
      if (isNaN(numValue)) return;
      if (numValue < 0) return;
      if (numValue > 100) return;
    }

    setManufacturingDetail({
      ...manufacturingDetail,
      [target.name]: value
    });
  }

  function handleChangeDate(e) {
    const target = e.target;
    const value = target.value;

    setManufacturingDetail((prevDetails) => {
      const updatedDetails = {
        ...prevDetails,
        [target.name]: value,
      };

      if (target.name === "fromDateOfManufacture" &&
        (!prevDetails.toDateOfManufacture || prevDetails.toDateOfManufacture < value)) {
        updatedDetails.toDateOfManufacture = value;
      }

      if (target.name === "fromDateOfCrop" &&
        (!prevDetails.toDateOfCrop || prevDetails.toDateOfCrop < value)) {
        updatedDetails.toDateOfCrop = value;
      }

      if (target.name === "fromDateOfManufacture") {
        const formattedDate = formatDateToLocal(value);
        setWitheringDetails((prevState) => ({
          ...prevState,
          startDate: formattedDate,
          endDate: formattedDate
        }));
      }

      return updatedDetails;
    });
  }

  function handleRollingChange(e) {
    const target = e.target;
    const value = target.value

    setRollingDetails({
      ...rollingDetails,
      manufactureTypeID: value,
      manufactureTypeCode: manufactureTypes.find(x => x.manufactureTypeID == parseInt(value))?.manufactureTypeCode
    });
  }

  function generateDropDownMenu(data) {
    let items = []
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
      }
    }
    return items;
  }

  function generateFactoryDropDownMenu(data) {
    let items = []
    if (data != null) {
      const sortedFactories = [...factoryList].sort((a, b) =>
        a.factoryName.localeCompare(b.factoryName)
      );
      sortedFactories.forEach(x => {
        items.push(<MenuItem key={x.factoryID} value={x.factoryID}>{x.factoryName}</MenuItem>)
      });
    }
    return items
  }

  function generateManufactureTypesDropDownMenu(data) {
    let items = []
    if (data != null) {
      data.forEach(x => {
        items.push(<MenuItem key={x.manufactureTypeID} value={x.manufactureTypeID}>{x.manufactureTypeName}</MenuItem>)
      });
    }
    return items
  }

  async function saveManufacture(params) {
    let statusID = 0;
    let manufactureStatus = 0;
    if (parseInt(manufacturingDetail.best) + parseInt(manufacturingDetail.belowBest) + parseInt(manufacturingDetail.poor) === 100 || parseInt(manufacturingDetail.best) + parseInt(manufacturingDetail.belowBest) + parseInt(manufacturingDetail.poor) === 0) {
      if (parseFloat(manufacturingDetail.greenLeafAmount) < parseFloat(witheringDetails.witheredLeafAmount)) {
        alert.error("Withered Leaf should be less than Green Leaf Quantity!");
        return;
      }
      else if (rollingDetails.manufactureTypeCode != "03" && witheredLeafValidation()) {
        alert.error("Please fill the Withered Leaf Details!");
        return;
      }
      else if (rollingValidation()) {
        alert.error("Please fill the Rolling Details!");
        return;
      }
      else if (firingValidation()) {
        alert.error("Please fill the Firing Details!");
        return;
      }

      statusID = arrayField.length > 0 && arrayFuel.length < 0 ? 5 : arrayField.length > 0 && arrayFuel.length > 0 ? 6 : 4

      if (arrayField.length > 0 && arrayFuel.length > 0) {
        manufactureStatus = 5;
      } else if (arrayField.length > 0) {
        manufactureStatus = 4;
      }
      else if (parseFloat(firingDetails.fireWeight) > 0) {
        manufactureStatus = 3;
      }
      else if (parseFloat(rollingDetails.noOfDhool) > 0) {
        manufactureStatus = 2;
      }
      else {
        manufactureStatus = 1;
      }

      let model = {
        manufacturingID: parseInt(decryptedIDD),
        groupID: parseInt(manufacturingDetail.groupID),
        factoryID: parseInt(manufacturingDetail.factoryID),
        greenLeafQuantity: parseFloat(manufacturingDetail.greenLeafAmount),
        boughtLeafWeight: parseFloat(manufacturingDetail.boughtLeafWeight),
        estateLeafWeight: parseFloat(manufacturingDetail.estateLeafWeight),
        interEstateLeafWeight: parseFloat(manufacturingDetail.interEstateLeafWeight),
        fromDateOfCrop: manufacturingDetail.fromDateOfCrop,
        toDateOfCrop: manufacturingDetail.toDateOfCrop,
        fromDateOfManufacture: manufacturingDetail.fromDateOfManufacture,
        toDateOfManufacture: manufacturingDetail.toDateOfManufacture,
        best: manufacturingDetail.best == "" ? parseFloat(0) : parseFloat(manufacturingDetail.best),
        belowBest: manufacturingDetail.belowBest == "" ? parseFloat(0) : parseFloat(manufacturingDetail.belowBest),
        poor: manufacturingDetail.poor == "" ? parseFloat(0) : parseFloat(manufacturingDetail.poor),
        refuseAmount: parseFloat(gradeDetails.refuseAmount),
        refusePercentage: isUpdate ? parseFloat((gradeDetails.refuseAmount / firingDetails.fireWeight) * 100) : parseFloat(gradeDetails.refusePercentage),
        netOutTurn: isUpdate ? parseFloat((arrayField.reduce((accumulator, current) => accumulator + current.gradingAmount, 0) / manufacturingDetail.greenLeafAmount) * 100) : parseFloat(gradeDetails.netOutTurn),
        grossOutTurn: isUpdate ? parseFloat((firingDetails.fireWeight / manufacturingDetail.greenLeafAmount) * 100) : parseFloat(firingDetails.grossOutTurn),
        grandGrossOutTurn: isUpdate ? parseFloat((firingDetails.totalFireWeight / manufacturingDetail.greenLeafAmount) * 100) : parseFloat(firingDetails.grandGrossOutTurn),

        startDate: rollingDetails.manufactureTypeCode == "03" ? null : witheringDetails.startDate,
        endDate: rollingDetails.manufactureTypeCode == "03" ? null : witheringDetails.endDate,
        witheredLeafAmount: parseFloat(witheringDetails.witheredLeafAmount),
        witheredLeafPercentage: rollingDetails.manufactureTypeCode == "03" ? parseFloat(0) : parseFloat(witheringDetails.witheredLeafPercentage),
        witheringCondition: rollingDetails.manufactureTypeCode == "03" ? parseFloat(0) : parseInt(witheringDetails.witheringCondition),

        manufactureTypeID: parseInt(rollingDetails.manufactureTypeID),
        manufactureTypeCode: rollingDetails.manufactureTypeCode,
        rollingStartTime: rollingDetails.rollingStartTime == "" ? null : rollingDetails.rollingStartTime,
        rollingEndDate: rollingDetails.rollingEndDate == "" ? null : rollingDetails.rollingEndDate,
        noOfDhool: parseFloat(rollingDetails.noOfDhool),
        noOfBatch: parseFloat(rollingDetails.noOfBatch),

        startDateTime: firingDetails.startDateTime == "" ? null : firingDetails.startDateTime,
        endDateTime: firingDetails.endDateTime == "" ? null : firingDetails.endDateTime,
        fireWeight: parseFloat(firingDetails.fireWeight),
        totalFireWeight: parseFloat(firingDetails.totalFireWeight),
        moistureGain: parseFloat(firingDetails.moistureGain),
        temperature: parseFloat(firingDetails.temperature),
        temperatureUnitID: parseInt(firingDetails.temperatureUnitID),

        statusID: statusID,
        manufactureStatus: manufactureStatus,
        createdBy: tokenService.getUserIDFromToken(),
        gradingDetails: arrayField,
        fuelDetails: arrayFuel,
        greenLeafDetails: greenLeafArray,
        dhoolDetails: firingDetails.selectedDhools,
      }
      if (!isUpdate) {
        var res = await services.SaveNewManufacture(model);
        if (res.statusCode == "Success") {
          alert.success(res.message);
          navigate('/app/newmanufacturing/listing');
        }
        else {
          alert.error(res.message);
        }
      }
      else {
        var res = await services.UpdateNewManufacture(model);
        if (res.statusCode == "Success") {
          alert.success(res.message);
          navigate('/app/newmanufacturing/listing');
        }
        else {
          alert.error(res.message);
        }
      }
    }
    else {
      alert.error("Summation of Best, Below Best & Poor must be 100%")
    }
  }

  function witheredLeafValidation() {
    if (witheringDetails.startDate != "" &&
      witheringDetails.endDate != "" &&
      witheringDetails.witheringCondition != 0 &&
      witheringDetails.witheredLeafAmount != 0) {
      return false;
    }
    else {
      return true;
    }
  }

  function rollingValidation() {
    if ((rollingDetails.noOfDhool != 0 && rollingDetails.noOfBatch == 0) || (rollingDetails.noOfDhool == 0 && rollingDetails.noOfBatch != 0)) {
      return true;
    }
    else {
      return false;
    }
  }

  function firingValidation() {
    if ((firingDetails.fireWeight != 0 && (firingDetails.temperature == 0 || firingDetails.temperatureUnitID == 0)) || (firingDetails.temperature != 0 && (firingDetails.fireWeight == 0 || firingDetails.temperatureUnitID == 0)) || (firingDetails.temperatureUnitID != 0 && (firingDetails.fireWeight == 0 || firingDetails.temperature == 0))) {
      return true;
    }
    else {
      return false;
    }
  }

  const onKeyDown = (e) => {
    e.preventDefault();
  };

  const getScreenName = (decryptedStatusIDD) => {
    if (decryptedStatusIDD == 0)
      return 'Add Manufacture';
    else if (decryptedStatusIDD == 1)
      return 'Update Manufacture';
    else if (decryptedStatusIDD == 2)
      return 'View Manufacture';
    else if (decryptedStatusIDD == 3)
      return 'Approve Manufacture';
    else
      return '';
  };

  function cancelDataOne() {
    setDialogboxOne(false);
  }

  function cancelDataTwo() {
    setDialogboxTwo(false);
  }

  function handleApprove() {
    setDialogboxOne(true);
  }

  function handleReject() {
    setDialogboxTwo(true)
  }

  async function confirmDataOne() {
    setDialogboxOne(false);
    if (arrayField.length != 0) {
      let result = [];
      arrayField.forEach(x => {
        const found = warehouseList.find(y => y.skuCategoryID == x.gradeCategoryID && y.skuMasterID == x.gradeID)
        if (found) {
          result.push({
            groupID: parseInt(manufacturingDetail.groupID),
            factoryID: parseInt(manufacturingDetail.factoryID),
            manufactureNumber: manufacturingDetail.manufactureNumber,
            manufacturingID: parseInt(decryptedIDD),
            binID: found.binID,
            binName: found.binName,
            itemDetailsID: found.itemDetailsID,
            skuCategoryID: found.skuCategoryID,
            skuMasterCode: found.skuMasterCode,
            skuMasterID: found.skuMasterID,
            warehouseID: found.warehouseID,
            warehouseSKUMappingID: found.warehouseSKUMappingID,
            gradingAmount: x.gradingAmount,
            createdBy: tokenService.getUserIDFromToken(),
          })
        }
      })

      if (arrayField.length != result.length) {
        alert.error("Please setup the bin for the each Grade!");
        return;
      }

      const hasInvalidData = result.some(item =>
        !item.skuMasterID || item.skuMasterID === 0 ||
        !item.manufacturingID || item.manufacturingID === 0 ||
        !item.manufactureNumber || item.manufactureNumber.trim() === ""
      );

      if (hasInvalidData) {
        alert.error("Cannot approve: Missing required data!");
        return;
      }

      var res = await services.ApproveManufactureDetails(result);
      if (res.statusCode == "Success") {
        alert.success(res.message);
        navigate('/app/newmanufacturing/listing');
      }
      else {
        alert.error(res.message);
      }
    }
    else {
      alert.error("Please complete grading details before approval.");
      return;
    }
  }

  async function confirmDataTwo() {
    setDialogboxTwo(false);
    let model = {
      manufacturingID: parseInt(decryptedIDD),
      createdBy: tokenService.getUserIDFromToken()
    }
    var res = await services.RejectManufactureDetails(model);
    if (res.statusCode == "Success") {
      alert.success(res.message);
      navigate('/app/newmanufacturing/listing');
    }
    else {
      alert.error(res.message);
    }
  }

  const handleNext = () => {
    setValue((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setValue((prevActiveStep) => prevActiveStep - 1);
  };

  return (
    <Fragment>
      <LoadingComponent />
      <Page className={classes.root} title={getScreenName(decryptedStatusIDD)}>
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: manufacturingDetail.groupID,
              factoryID: manufacturingDetail.factoryID,
              manufactureTypeID: rollingDetails.manufactureTypeID,
              manufactureNumber: manufacturingDetail.manufactureNumber,
              greenLeafAmount: manufacturingDetail.greenLeafAmount,
              boughtLeafWeight: manufacturingDetail.boughtLeafWeight,
              estateLeafWeight: manufacturingDetail.estateLeafWeight,
              interEstateLeafWeight: manufacturingDetail.interEstateLeafWeight,
              fromDateOfCrop: manufacturingDetail.fromDateOfCrop,
              toDateOfCrop: manufacturingDetail.toDateOfCrop,
              fromDateOfManufacture: manufacturingDetail.fromDateOfManufacture,
              toDateOfManufacture: manufacturingDetail.toDateOfManufacture,
              best: manufacturingDetail.best,
              belowBest: manufacturingDetail.belowBest,
              poor: manufacturingDetail.poor,
            }}
            validationSchema={
              Yup.object().shape({
                groupID: Yup.number().required('Group is required').min("1", 'Please Select a Group'),
                factoryID: Yup.number().required('Factory is required').min("1", 'Please Select a Factory'),
                manufactureTypeID: Yup.number().required('Manufacture Type is required').min("1", 'Manufacture Type is required'),
                fromDateOfCrop: Yup.date().required('From Date Of Crop is required').typeError('Invalid date'),
                toDateOfCrop: Yup.date().required('To Date Of Crop is required').typeError('Invalid date'),
                fromDateOfManufacture: Yup.date().required('From Date Of Manufacture is required').typeError('Invalid date'),
                toDateOfManufacture: Yup.date().required('To Date Of Manufacture is required').typeError('Invalid date'),
                greenLeafAmount: Yup.number().required(rollingDetails.manufactureTypeCode != "03" ?
                  'Green Leaf Quantity is required' : 'Refuse Tea Quantity is required')
                  .min(0.1, rollingDetails.manufactureTypeCode != "03" ?
                    'Green Leaf Quantity must be above 0' : 'Refuse Tea Quantity should be grater than 0'),
                boughtLeafWeight: Yup.number()
                  .max(maxQty.boughtLeafMaxWeight, "Value cannot exceed the maximum allowed"),
                best: Yup.number()
                  .typeError('Value must be a number')
                  .min(0, 'Value must be at least 0')
                  .max(100, 'Value cannot exceed 100'),
                belowBest: Yup.number()
                  .typeError('Value must be a number')
                  .min(0, 'Value must be at least 0')
                  .max(100, 'Value cannot exceed 100'),
                poor: Yup.number()
                  .typeError('Value must be a number')
                  .min(0, 'Value must be at least 0')
                  .max(100, 'Value cannot exceed 100'),
              })
            }
            onSubmit={(event) => trackPromise(saveManufacture(event))}
            enableReinitialize
          >
            {({
              errors,
              handleBlur,
              handleSubmit,
              touched,
              isSubmitting
            }) => (
              <form onSubmit={handleSubmit}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    handleSubmit();
                  }
                }}
              >
                <Box mt={0}>
                  <Card>
                    <CardHeader title={cardTitle(getScreenName(decryptedStatusIDD))} />
                    <Divider />
                    <CardContent>
                      <Grid container spacing={3}>
                        <Grid item md={3} xs={8}>
                          <InputLabel shrink id="groupID">
                            Group *
                          </InputLabel>
                          <TextField select
                            error={Boolean(touched.groupID && errors.groupID)}
                            fullWidth
                            helperText={touched.groupID && errors.groupID}
                            name="groupID"
                            onBlur={handleBlur}
                            onChange={(e) => handleChange(e)}
                            value={manufacturingDetail.groupID}
                            variant="outlined"
                            id="groupID"
                            size='small'
                            InputProps={{
                              readOnly: !permissionList.isGroupFilterEnabled || isUpdate
                            }}
                          >
                            <MenuItem value="0">--Select Group--</MenuItem>
                            {generateDropDownMenu(GroupList)}
                          </TextField>
                        </Grid>
                        <Grid item md={3} xs={8}>
                          <InputLabel shrink id="factoryID">
                            Factory *
                          </InputLabel>
                          <TextField select
                            error={Boolean(touched.factoryID && errors.factoryID)}
                            fullWidth
                            helperText={touched.factoryID && errors.factoryID}
                            name="factoryID"
                            onBlur={handleBlur}
                            onChange={(e) => handleChange(e)}
                            value={manufacturingDetail.factoryID}
                            variant="outlined"
                            id="factoryID"
                            size='small'
                            InputProps={{
                              readOnly: !permissionList.isFactoryFilterEnabled || isUpdate
                            }}
                          >
                            <MenuItem value="0">--Select Factory--</MenuItem>
                            {generateFactoryDropDownMenu(factoryList)}
                          </TextField>
                        </Grid>
                        {isUpdate ?
                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="manufactureNumber">
                              Manufacture Number *
                            </InputLabel>
                            <TextField
                              error={Boolean(touched.manufactureNumber && errors.manufactureNumber)}
                              fullWidth
                              helperText={touched.manufactureNumber && errors.manufactureNumber}
                              name="manufactureNumber"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={manufacturingDetail.manufactureNumber}
                              variant="outlined"
                              size='small'
                              id="manufactureNumber"
                              InputProps={{
                                readOnly: true
                              }}
                            >
                            </TextField>
                          </Grid> : null}
                        <Grid item md={3} xs={8}>
                          <InputLabel shrink id="manufactureTypeID">
                            Manufacture Type *
                          </InputLabel>
                          <TextField
                            select
                            error={Boolean(touched.manufactureTypeID && errors.manufactureTypeID)}
                            fullWidth
                            helperText={touched.manufactureTypeID && errors.manufactureTypeID}
                            name="manufactureTypeID"
                            onBlur={handleBlur}
                            onChange={(e) => handleRollingChange(e)}
                            value={rollingDetails.manufactureTypeID}
                            variant="outlined"
                            id="manufactureTypeID"
                            size='small'
                            InputProps={{
                              readOnly: isUpdate
                            }}
                          >
                            <MenuItem value="0">--Select Manufacture Type--</MenuItem>
                            {generateManufactureTypesDropDownMenu(manufactureTypes)}
                          </TextField>
                        </Grid>
                        <Grid item md={3} xs={8}>
                          <InputLabel shrink id="fromDateOfCrop">
                            From Date Of Crop *
                          </InputLabel>
                          <TextField
                            fullWidth
                            type="date"
                            error={Boolean(touched.fromDateOfCrop && errors.fromDateOfCrop)}
                            helperText={touched.fromDateOfCrop && errors.fromDateOfCrop}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            name="fromDateOfCrop"
                            onBlur={handleBlur}
                            onChange={(e) => handleChangeDate(e)}
                            value={manufacturingDetail.fromDateOfCrop}
                            variant="outlined"
                            id="fromDateOfCrop"
                            size='small'
                            onKeyDown={onKeyDown}
                            inputProps={{
                              max: new Date().toISOString().split('T')[0],
                              readOnly: isUpdate
                            }}
                          >
                          </TextField>
                        </Grid>
                        <Grid item md={3} xs={8}>
                          <InputLabel shrink id="toDateOfCrop">
                            To Date Of Crop *
                          </InputLabel>
                          <TextField
                            fullWidth
                            type="date"
                            error={Boolean(touched.toDateOfCrop && errors.toDateOfCrop)}
                            helperText={touched.toDateOfCrop && errors.toDateOfCrop}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            name="toDateOfCrop"
                            onBlur={handleBlur}
                            onChange={(e) => handleChange(e)}
                            value={manufacturingDetail.toDateOfCrop}
                            variant="outlined"
                            id="toDateOfCrop"
                            size='small'
                            inputProps={{
                              max: new Date().toISOString().split('T')[0],
                              min: manufacturingDetail.fromDateOfCrop
                            }}
                            InputProps={{
                              readOnly: isUpdate
                            }}
                            onKeyDown={onKeyDown}
                          >
                          </TextField>
                        </Grid>
                        {(rollingDetails.manufactureTypeCode != "03") ?
                          <>
                            <Grid item md={3} xs={8}>
                              <InputLabel shrink id="boughtLeafWeight">
                                Bought Leaf Weight Qty (Kg) *
                              </InputLabel>
                              <TextField
                                type='number'
                                error={Boolean(touched.boughtLeafWeight && errors.boughtLeafWeight)}
                                fullWidth
                                helperText={touched.boughtLeafWeight && errors.boughtLeafWeight}
                                name="boughtLeafWeight"
                                onBlur={handleBlur}
                                size='small'
                                onChange={(e) => handleChange(e)}
                                value={manufacturingDetail.boughtLeafWeight}
                                variant="outlined"
                                id="boughtLeafWeight"
                                InputProps={{
                                  readOnly: witheringDetails.witheredLeafAmount > 0 || isUpdate,
                                  inputProps: {
                                    step: 0.01,
                                    type: 'number',
                                    style: {
                                      textAlign: 'right',
                                    },
                                  },
                                }}
                                onKeyDown={(evt) =>
                                  (evt.key === "-") && evt.preventDefault()
                                }
                                onWheel={event => event.target.blur()}
                              >
                              </TextField>
                            </Grid>
                          </>
                          :
                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="greenLeafAmount">
                              Refuse Tea Quantity (Kg) *
                            </InputLabel>
                            <TextField
                              type='number'
                              error={Boolean(touched.greenLeafAmount && errors.greenLeafAmount)}
                              fullWidth
                              helperText={touched.greenLeafAmount && errors.greenLeafAmount}
                              name="greenLeafAmount"
                              onBlur={handleBlur}
                              size='small'
                              onChange={(e) => handleChange(e)}
                              value={manufacturingDetail.greenLeafAmount}
                              variant="outlined"
                              id="greenLeafAmount"
                              InputProps={{
                                readOnly: true,
                                inputProps: {
                                  step: 0.01,
                                  type: 'number',
                                  style: {
                                    textAlign: 'right',
                                  },
                                },
                              }}
                              onKeyDown={(evt) =>
                                (evt.key === "-") && evt.preventDefault()
                              }
                              onWheel={event => event.target.blur()}
                            >
                            </TextField>
                          </Grid>}
                        <Grid item md={3} xs={8}>
                          <InputLabel shrink id="fromDateOfManufacture">
                            From Date Of Manufacture *
                          </InputLabel>
                          <TextField
                            fullWidth
                            type="date"
                            error={Boolean(touched.fromDateOfManufacture && errors.fromDateOfManufacture)}
                            helperText={touched.fromDateOfManufacture && errors.fromDateOfManufacture}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            name="fromDateOfManufacture"
                            onBlur={handleBlur}
                            onChange={(e) => handleChangeDate(e)}
                            value={manufacturingDetail.fromDateOfManufacture}
                            variant="outlined"
                            id="fromDateOfManufacture"
                            size='small'
                            onKeyDown={onKeyDown}
                            inputProps={{
                              max: new Date().toISOString().split('T')[0],
                              readOnly: isUpdate
                            }}
                          >
                          </TextField>
                        </Grid>
                        <Grid item md={3} xs={8}>
                          <InputLabel shrink id="toDateOfManufacture">
                            To Date Of Manufacture *
                          </InputLabel>
                          <TextField
                            fullWidth
                            type="date"
                            error={Boolean(touched.toDateOfManufacture && errors.toDateOfManufacture)}
                            helperText={touched.toDateOfManufacture && errors.toDateOfManufacture}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            name="toDateOfManufacture"
                            onBlur={handleBlur}
                            onChange={(e) => handleChange(e)}
                            value={manufacturingDetail.toDateOfManufacture}
                            variant="outlined"
                            id="toDateOfManufacture"
                            size='small'
                            inputProps={{
                              min: manufacturingDetail.fromDateOfManufacture,
                              max: new Date().toISOString().split('T')[0]
                            }}
                            InputProps={{
                              readOnly: isUpdate,
                            }}
                            onKeyDown={onKeyDown}
                          >
                          </TextField>
                        </Grid>
                        <Grid item md={3} xs={8}>
                          <InputLabel shrink id="best">
                            Best (%)
                          </InputLabel>
                          <TextField
                            error={Boolean((touched.best && errors.best) || percentageError)}
                            fullWidth
                            helperText={touched.best && errors.best}
                            name="best"
                            onBlur={handleBlur}
                            size='small'
                            onChange={(e) => handleChange(e)}
                            value={manufacturingDetail.best}
                            variant="outlined"
                            id="best"
                            min="0"
                            max="100"
                            InputProps={{
                              readOnly: isUpdate,
                              inputProps: {
                                step: 0.01,
                                type: 'number',
                                style: {
                                  textAlign: 'right',
                                },
                              },
                            }}
                            onKeyDown={(evt) =>
                              (evt.key === "-") && evt.preventDefault()
                            }
                            onWheel={event => event.target.blur()}
                          >
                          </TextField>
                        </Grid>
                        <Grid item md={3} xs={8}>
                          <InputLabel shrink id="belowBest">
                            Below Best (%)
                          </InputLabel>
                          <TextField
                            error={Boolean((touched.belowBest && errors.belowBest) || percentageError)}
                            fullWidth
                            helperText={touched.belowBest && errors.belowBest}
                            name="belowBest"
                            onBlur={handleBlur}
                            size='small'
                            onChange={(e) => handleChange(e)}
                            value={manufacturingDetail.belowBest}
                            variant="outlined"
                            min="0"
                            max="100"
                            id="belowBest"
                            InputProps={{
                              readOnly: isUpdate,
                              inputProps: {
                                step: 0.01,
                                type: 'number',
                                style: {
                                  textAlign: 'right',
                                },
                              },
                            }}
                            onKeyDown={(evt) =>
                              (evt.key === "-") && evt.preventDefault()
                            }
                            onWheel={event => event.target.blur()}
                          >
                          </TextField>
                        </Grid>
                        <Grid item md={3} xs={8}>
                          <InputLabel shrink id="poor">
                            Poor (%)
                          </InputLabel>
                          <TextField
                            error={Boolean((touched.poor && errors.poor) || percentageError)}
                            fullWidth
                            helperText={touched.poor && errors.poor || (percentageError && "Sum of Best(%), Below Best(%) and Poor(%) must be 100%")}
                            name="poor"
                            onBlur={handleBlur}
                            size='small'
                            onChange={(e) => handleChange(e)}
                            value={manufacturingDetail.poor}
                            variant="outlined"
                            min="0"
                            max="100"
                            id="poor"
                            InputProps={{
                              readOnly: isUpdate,
                              inputProps: {
                                step: 0.01,
                                type: 'number',
                                style: {
                                  textAlign: 'right',
                                },
                              },
                            }}
                            onKeyDown={(evt) =>
                              (evt.key === "-") && evt.preventDefault()
                            }
                            onWheel={event => event.target.blur()}
                          >
                          </TextField>
                        </Grid>
                      </Grid>
                      &nbsp;
                      <Box>
                        <Paper square>
                          <TabContext value={value}>
                            <AppBar position="static">
                              <TabList
                                centered="true"
                                onMouseDown={(e) => e.preventDefault()}
                                variant={'fullWidth'}
                                aria-label="simple tabs example"
                              >
                                <Tab
                                  label="Withered Leaf"
                                  value={rollingDetails.manufactureTypeCode != "03" ? 1 : 0}
                                  style={{
                                    color: "white",
                                    backgroundColor: value === (rollingDetails.manufactureTypeCode != "03" ? 1 : 0) ? "#1976d2" : "inherit"
                                  }}
                                  disabled={rollingDetails.manufactureTypeCode == "03" ? true : false}
                                />
                                <Tab
                                  label="Rolling"
                                  value={rollingDetails.manufactureTypeCode != "03" ? 2 : 1}
                                  style={{
                                    color: "white",
                                    backgroundColor: value === (rollingDetails.manufactureTypeCode != "03" ? 2 : 1) ? "#1976d2" : "inherit"
                                  }}
                                  disabled={false}
                                />
                                <Tab
                                  label="Firing"
                                  value={rollingDetails.manufactureTypeCode != "03" ? 3 : 2}
                                  style={{
                                    color: "white",
                                    backgroundColor: value === (rollingDetails.manufactureTypeCode != "03" ? 3 : 2) ? "#1976d2" : "inherit"
                                  }}
                                  disabled={false}
                                />
                                <Tab
                                  label="Grading"
                                  value={rollingDetails.manufactureTypeCode != "03" ? 4 : 3}
                                  style={{
                                    color: "white",
                                    backgroundColor: value === (rollingDetails.manufactureTypeCode != "03" ? 4 : 3) ? "#1976d2" : "inherit"
                                  }}
                                  disabled={false}
                                />
                              </TabList>
                            </AppBar>
                            <TabPanel style={{ border: "1px solid black" }} value={rollingDetails.manufactureTypeCode != "03" ? 1 : 0}>
                              <WitheredLeaf handleNext={handleNext} witheringDetails={witheringDetails} setWitheringDetails={setWitheringDetails}
                                rollingDetails={rollingDetails} setRollingDetails={setRollingDetails} manufacturingDetail={manufacturingDetail} StatusID={decryptedStatusIDD}
                                firingDetails={firingDetails} isUpdate={isUpdate}/>
                            </TabPanel>
                            <TabPanel style={{ border: "1px solid black" }} value={rollingDetails.manufactureTypeCode != "03" ? 2 : 1}>
                              <Rolling handleNext={handleNext} handleBack={handleBack} manufacturingDetail={manufacturingDetail} rollingDetails={rollingDetails}
                                setRollingDetails={setRollingDetails} witheringDetails={witheringDetails}
                                factoryID={manufacturingDetail.factoryID} isUpdate={isUpdate} StatusID={decryptedStatusIDD} />
                            </TabPanel>
                            <TabPanel style={{ border: "1px solid black" }} value={rollingDetails.manufactureTypeCode != "03" ? 3 : 2}>
                              <Fiering handleNext={handleNext} handleBack={handleBack} isUpdate={isUpdate} firingDetails={firingDetails} rollingDetails={rollingDetails}
                                setFiringDetails={setFiringDetails} StatusID={decryptedStatusIDD} witheringDetails={witheringDetails}
                                manufacturingDetail={manufacturingDetail} selectedDhools={rollingDetails.selectedDhools} gradeDetails={gradeDetails} />
                            </TabPanel>
                            <TabPanel style={{ border: "1px solid black" }} value={rollingDetails.manufactureTypeCode != "03" ? 4 : 3}>
                              <Grading handleBack={handleBack} factoryData={manufacturingDetail.factoryID} setIsGrading={setIsGrading}
                                firingDetails={firingDetails} arrayField={arrayField}
                                setFiringDetails={setFiringDetails} setArrayField={setArrayField} gradeDetails={gradeDetails} setGradeDetails={setGradeDetails}
                                StatusID={decryptedStatusIDD} manufacturingDetail={manufacturingDetail} isUpdate={isUpdate} />
                            </TabPanel>
                          </TabContext>
                        </Paper>
                      </Box>
                      &nbsp;
                      <Paper style={{ border: "1px solid black" }} square>
                        <Grid style={{ margin: '20px', marginBottom: '20px' }}>
                          <FuelConsume factoryData={manufacturingDetail.factoryID} arrayFuel={arrayFuel} setArrayFuel={setArrayFuel} StatusID={decryptedStatusIDD} />
                        </Grid>
                      </Paper>
                      &nbsp;
                      <Grid spacing={3}>
                        <Box display="flex" justifyContent="right">
                          {decryptedStatusIDD == 0 || decryptedStatusIDD == 1 ?
                            <Button
                              color="primary"
                              variant="contained"
                              type='submit'
                              size='small'
                            >
                              {isUpdate == true ? "Update" : "Save"}
                            </Button> : null}
                          &nbsp;
                          {/* {decryptedStatusIDD == 3 ?
                            <Button
                              color="red"
                              type="button"
                              variant="contained"
                              size='small'
                              style={{
                                backgroundColor: "red",
                                color: "white"
                              }}
                              onClick={() => handleReject()}
                            >
                              Reject
                            </Button> : null} */}
                          &nbsp;
                          {decryptedStatusIDD == 3 && permissionList.isApproveButtonEnabled ?
                            <Button
                              color="green"
                              type="button"
                              variant="contained"
                              size='small'
                              style={{
                                backgroundColor: "green",
                                color: "white"
                              }}
                              onClick={() => handleApprove()}
                            >
                              Approve
                            </Button> : null}
                        </Box>
                      </Grid>
                    </CardContent>
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Page>
      {dialogboxOne ? <AlertDialogWithoutButton confirmData={confirmDataOne} cancelData={cancelDataOne}
        IconTitle={"Approve"}
        headerMessage={"Are you sure you want to approve ?"}
      /> : null}
      {dialogboxTwo ? <AlertDialogWithoutButton confirmData={confirmDataTwo} cancelData={cancelDataTwo}
        IconTitle={"Reject"}
        headerMessage={"Are you sure you want to reject ?"}
      /> : null}
    </Fragment>
  );
}
